import React from 'react'
import classNames from 'classnames'
import { IsViewport } from '@zambezi/layout-grid'
import { followStoreLink$ } from '../navigation'
import Avatar from './Avatar'
import StatusIcon from './StatusIcon'
import style from './PaymentCard.module.css'

export default function PaymentCard({
  showStatusIcon = true,
  description,
  avatarText,
  detailUrl,
  amountString,
  amountAnnotation,
  dateText,
  status,
  className,
}) {
  return (
    <button
      className={classNames(style.activeCard, className, 'legacyCard')}
      onClick={() => followStoreLink$.next(detailUrl)}
    >
      <div className={style.content}>
        <IsViewport isTablet isDesktop isWidescreen>
          <Avatar content={avatarText} className={style.avatar} />
        </IsViewport>
        <span className={classNames(style.clientName, 'js-client-name')}>
          {description}
        </span>

        <div
          className={classNames(style.information, 'js-payment-information')}
        >
          {dateText}
        </div>
        {showStatusIcon && (
          <StatusIcon status={status} className={style.statusIcon} />
        )}
        <div className={style.amount}>
          <span className="js-payment-amount">{amountString}</span>
          {amountAnnotation && (
            <span
              className={classNames(
                style.amountAnnotation,
                'js-payment-amount-annotation'
              )}
            >
              {amountAnnotation}
            </span>
          )}
        </div>
      </div>
    </button>
  )
}

export function EmptyPaymentCard({ label = 'payments' }) {
  return (
    <div className={classNames(style.card, 'js-payment-card-empty')}>
      <div className={style.content}>
        <IsViewport isTablet isDesktop isWidescreen>
          <Avatar className={style.hiddenAvatar} />
        </IsViewport>
        <span className={classNames(style.emptyMessage, 'js-message')}>
          You have no {label.toLowerCase()}
        </span>
      </div>
    </div>
  )
}
